module.exports = __webpack_public_path__ + "cancellara-dist/img/upday.8ec3e6ab.png";